import { gql } from '@apollo/client/core';
import { useMutation } from '@vue/apollo-composable';
import { addRemoveMembersFromGroup } from '@spectee/graphql/mutations';

const document = gql(addRemoveMembersFromGroup);

export function useAddRemoveMembersFromGroup() {
  return useMutation(document);
}
